import React, { useCallback, useContext, useEffect, useState } from "react";
import "../../Styles/Form/FormCreate.css";
import shortAnswer from "../../Assets/shortAnswer.svg";
import paragraph from "../../Assets/paragraph.svg";
import RatingScale from "../../Assets/RatingScale.svg";
import website from "../../Assets/website.svg";
import timer from "../../Assets/timer.svg";
import payament from "../../Assets/payament.svg";
import AddProduct from "../../Assets/AddProduct.svg";
import captcha from "../../Assets/captcha.svg";
import Appointment from "../../Assets/Appointment.svg";
import section from "../../Assets/section.svg";
import tagCloseIcon from "../../Assets/tagCloseIcon.png";
import { IoIosAddCircleOutline } from "react-icons/io";
import dropDown from "../../Assets/dropDown.svg";
import linescale from "../../Assets/linescale.svg";
import multipleChoiceGrid from "../../Assets/multipleChoiceGrid.svg";
import * as FaIcons from "react-icons/fa";
import tickboxGrid from "../../Assets/tickboxGrid.svg";
import name from "../../Assets/Name.svg";
import location from "../../Assets/location.svg";
import phone from "../../Assets/phone.svg";
import email from "../../Assets/email.svg";
import number from "../../Assets/number.svg";
import date from "../../Assets/date.svg";
import dateAndTime from "../../Assets/dateAndTime.svg";
import signature from "../../Assets/signature.svg";
import audiovideo from "../../Assets/audiovideo.svg";
import fileUpload from "../../Assets/fileUpload.svg";
import spinner from "../../Assets/spinner.svg";
import singleCProDndIcon from "../../Assets/singleCProDndIcon.svg";
import singleCProDeleteIcon from "../../Assets/singleCProDeleteIcon.svg";
import singleCProAddIcon from "../../Assets/singleCProAddIcon.svg";
import CheckBoxIcon from "../../Assets/CheckBoxIcon.svg";
import MultipleChoiceIcon from "../../Assets/MultipleChoiceIcon.svg";
import addbtnmultiplegrid from "../../Assets/add-btn-multiple-grid.svg";
import chevrondownl from "../../Assets/chevron-downl.png";
import chevronup from "../../Assets/chevron-up.png";
import { v4 as uuidv4 } from "uuid";
import "../../Styles/Form/ShearModel.css";
import Select, { components } from "react-select";
import {
  DndContext,
  DragOverlay,
  KeyboardSensor,
  PointerSensor,
  closestCorners,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  sortableKeyboardCoordinates,
  useSortable,
} from "@dnd-kit/sortable";
import Container from "./Container";
import Items from "./Items";
import "../../Styles/Form/FormCreate.css";
import TextComponent from "./TextComponent";
import "react-quill/dist/quill.snow.css";
import { PageContext } from "../../Context/PageContext";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  MoveQuestion,
  QuestionDnd,
  addAddress,
  addMultiChoice,
  addOptionSingleChoiceopPro,
  changeMultipleOption,
  createForm,
  createNewForm,
  createNewSection,
  deleteMultiChoice,
  deleteSingleChoiseOption,
  emptysectionmove,
  removeAddress,
  reomveTag,
  sectionDnd,
  updateDateAutoFill,
  updateFileTypes,
  updateFormOverQuestion,
  updateFormTitle,
  updateItemQuestion,
  updateOpton,
  updateSingleChoiceOp,
  updatevalueFrom,
} from "../../Redux/Reducer/FormSlices";
import { CSS } from "@dnd-kit/utilities";
import propertiesCloseIcon from "../../Assets/propertiesCloseIcon.svg";
import ReactQuill from "react-quill";
import axios from "axios";
import ReactModal from "react-modal";
import { fetchData } from "../../Api/FormApis";
import { SelectTag } from "../Tags/SelectTag";
import Addtag from "../Tags/Addtag";
import MoveSectionModel from "./MoveSectionModel";
import ShearModel from "./ShearModel";

const FormCreate = () => {
  const [activeId, setActiveId] = useState(null);
  const [draggedOverItemId, setDraggedOverItemId] = useState(null);
  const [currentContainerId, setCurrentContainerId] = useState();

  //Tag color get for background
  function hexToRGBA(hex, opacity) {
    // Remove the "#" if present
    hex = hex.replace("#", "");

    // Parse the r, g, b values from the hex string
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Return the rgba string with the specified opacity
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  //Tag hover
  const [tagHoveIdx, setTagHoverIdx] = useState(null); // tag
  const [isTagSelectionOpen, setTagSelectionOpen] = useState(false);
  const [isCreateTagOpen, setCreateTagOpen] = useState(false);
  const {
    openQuestionSetting,
    setOpenQuestionSetting,
    setActiveQuestion,
    setActiveContainerIndex,
    isSectionMoveModal,
    setShowSectionMoveModal,
  } = useContext(PageContext);

  const openCreateTagModal = () => {
    setCreateTagOpen(true);
    setTagSelectionOpen(false);
  };

  const closeTagSelectionModal = () => {
    setTagSelectionOpen(false);
  };

  const cancelTagAddModel = () => {
    setTagSelectionOpen(true);
    setCreateTagOpen(false);
  };

  const createTag = () => {
    setCreateTagOpen(false);
    setTagSelectionOpen(false);
  };

  const handelRemoveTag = (tagIndex) => {
    dispatch(reomveTag({ tagIndex }));
  };
  //movesection model
  const handelCloseSectionModal = () => {
    setShowSectionMoveModal(false);
  };

  const [all_tags, setAllTags] = useState([]);
  const URl = process.env.REACT_APP_API;
  const handelCreateForm = () => {
    axios
      .get(`${URl}/allTags`)
      .then((response) => {
        setAllTags(response.data.allTags);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const openTagSelectionModal = () => {
    handelCreateForm();
    setTagSelectionOpen(true);
  };

  const dispatch = useDispatch();

  const form = useSelector((state) => state.form?.form);
  console.log("111111111111111111111111111111111");
  console.log(form)
  console.log("111111111111111111111111111111111");
  
  useEffect(() => {
    // Set up the interval
    const intervalId = setInterval(() => {
      fetchData(form, dispatch, createNewForm);
      console.log(form);
    }, 30000); // Fetch data every 10 seconds
    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  });

  //TEXT ITEMS TO DRAGGABLE TEXT
  const [textItems, setTextItems] = useState([
    {
      id: `text-${uuidv4()}`,
      icon: <img src={shortAnswer} alt="shortAnswer" />,
      text: "Short Answer",
      type: "Short Answer",
    },
    {
      id: `text-${uuidv4()}`,
      icon: <img src={name} alt="name" />,
      text: "Name",
      type: "Name",
    },
    {
      id: `text-${uuidv4()}`,
      icon: <img src={paragraph} alt="paragraph" />,
      text: "Paragraph",
      type: "Paragraph",
    },
    {
      id: `text-${uuidv4()}`,
      icon: <img src={section} alt="section" />,
      text: "Section",
      type: "Section",
    },
    {
      id: `text-${uuidv4()}`,
      icon: <img src={phone} alt="phone" />,
      text: "Phone",
      type: "Phone",
    },
    {
      id: `text-${uuidv4()}`,
      icon: <img src={MultipleChoiceIcon} alt="MultipleChoiceIcon" />,
      text: "Multiple Choice",
      type: "Multiple Choice",
    },
    {
      id: `text-${uuidv4()}`,
      icon: <img src={CheckBoxIcon} alt="CheckBoxIcon" />,
      text: "Check box",
      type: "Check box",
    },
    {
      id: `text-${uuidv4()}`,
      icon: <img src={location} alt="location" />,
      text: "Location",
      type: "Location",
    },
    {
      id: `text-${uuidv4()}`,
      icon: <img src={email} alt="email" />,
      text: "Email",
      type: "Email",
    },

    {
      id: `text-${uuidv4()}`,
      icon: <img src={number} alt="number" />,
      text: "Number",
      type: "Number",
    },
    {
      id: `text-${uuidv4()}`,
      icon: <img src={linescale} alt="linescale" />,
      text: "Line Scale",
      type: "Line Scale",
    },
    {
      id: `text-${uuidv4()}`,
      icon: <img src={date} alt="date" />,
      text: "Date",
      type: "Date",
    },
    {
      id: `text-${uuidv4()}`,
      icon: <img src={multipleChoiceGrid} alt="multipleChoice" />,
      text: "Multiple Choice grid",
      type: "Multiple Choice grid",
    },
    // {
    //   id: `text-${uuidv4()}`,
    //   icon: <img src={time} alt="time" />,
    //   text: "Time",
    //   type: "Time",
    // },
    {
      id: `text-${uuidv4()}`,
      icon: <img src={tickboxGrid} alt="tickboxGrid" />,
      text: "Check box grid",
      type: "Check box grid",
    },
    {
      id: `text-${uuidv4()}`,
      icon: <img src={dateAndTime} alt="dateAndTime" />,
      text: "Date - Time",
      type: "Date - Time",
    },
    // {
    //   id: `text-${uuidv4()}`,
    //   icon: <img src={RatingScale} alt="RatingScale" />,
    //   text: "Rating Scale",
    //   type: "Rating Scale",
    // },
    {
      id: `text-${uuidv4()}`,
      icon: <img src={website} alt="website" />,
      text: "Website",
      type: "Website",
    },
    // {
    //   id: `text-${uuidv4()}`,
    //   icon: <img src={description} alt="description" />,
    //   text: "Description",
    //   type: "Description",
    // },
    {
      id: `text-${uuidv4()}`,
      icon: <img src={signature} alt="signature" />,
      text: "Signature",
      type: "Signature",
    },
    {
      id: `text-${uuidv4()}`,
      icon: <img src={audiovideo} alt="audiovideo" />,
      text: "Audio/Video Upload",
      type: "Audio/Video Upload",
    },
    {
      id: `text-${uuidv4()}`,
      icon: <img src={fileUpload} alt="fileUpload" />,
      text: "File Upload",
      type: "File Upload",
    },
    // {
    //   id: `text-${uuidv4()}`,
    //   icon: <img src={timer} alt="timer" />,
    //   text: "Timer",
    //   type: "Timer",
    // },
    // {
    //   id: `text-${uuidv4()}`,
    //   icon: <img src={AddProduct} alt="AddProduct" />,
    //   text: "AddProduct",
    //   type: "AddProduct",
    // },
    // {
    //   id: `text-${uuidv4()}`,
    //   icon: <img src={payament} alt="payament" />,
    //   text: "payament",
    //   type: "payament",
    // },
    // {
    //   id: `text-${uuidv4()}`,
    //   icon: <img src={captcha} alt="captcha" />,
    //   text: "Captcha",
    //   type: "Captcha",
    // },
    {
      id: `text-${uuidv4()}`,
      icon: <img src={spinner} alt="spinner" />,
      text: "Spinner",
      type: "Spinner",
    },
    // {
    //   id: `text-${uuidv4()}`,
    //   icon: <img src={Appointment} alt="Appointment" />,
    //   text: "Appointment",
    //   type: "Appointment",
    // },
    {
      id: `text-${uuidv4()}`,
      icon: <img src={dropDown} alt="dropDown" />,
      text: "Dropdown",
      type: "Dropdown",
    },
  ]);

  //FIND QUESTION BASED ON DROPPED TEXT
  const findquestion = (type) => {
    let newQuestion;
    switch (type) {
      case "Short Answer":
        newQuestion = {
          id: `item-${uuidv4()}`,
          question: "What is you name",
          type: "Short Answer",
          required: false,
          minWords: 2,
          maxWords: 25,
          sublabel: "",
          character: "Any character",
          placeHolder: "",
          errorText: "",
          correctAnswer: [],
        };
        break;
      case "Name":
        newQuestion = {
          id: `item-${uuidv4()}`,
          question: "Name",
          firstName: "First Name",
          lastName: "Last Name",
          firstNamePlaceHolder: "",
          lastNamePlaceHolder: "",
          sublabel: "",
          type: "Name",
          answer: "",
          required: false,
          errorText: "",
        };
        break;
      case "Paragraph":
        newQuestion = {
          id: `item-${uuidv4()}`,
          question: "Un question Paragraph",
          answer: "",
          type: "Paragraph",
          required: false,
          minWords: 25,
          maxWords: 50,
          sublabel: "",
          character: "",
          placeHolder: "",
          errorText: "",
        };
        break;
      case "Phone":
        newQuestion = {
          id: `item-${uuidv4()}`,
          type: "Phone",
          question: "Phone Number",
          sublabel: "",
          placeHolder: "",
          answer: "",
          required: false,
          errorText: "",
        };
        break;
      case "Multiple Choice":
        newQuestion = {
          id: `item-${uuidv4()}`,
          sublabel: "",
          question: "Which is capital of TamilNadu",
          options: [
            { id: `option-${uuidv4()}`, optionText: "Chennai" },
            { id: `option-${uuidv4()}`, optionText: "Erode" },
            { id: `option-${uuidv4()}`, optionText: "Coimbatore" },
            { id: `option-${uuidv4()}`, optionText: "Madurai" },
          ],
          type: "Multiple Choice",
          required: false,
          PredefinedOption: "none",
          errorText: "",
        };
        break;
      case "Check box":
        newQuestion = {
          id: `item-${uuidv4()}`,
          question: "Which is capital of TamilNadu",
          options: [
            { id: `option-${uuidv4()}`, optionText: "Chennai" },
            { id: `option-${uuidv4()}`, optionText: "Erode" },
            { id: `option-${uuidv4()}`, optionText: "Coimbatore" },
            { id: `option-${uuidv4()}`, optionText: "Madurai" },
          ],
          type: "Check box",
          sublabel: "",
          maxLimits: 0,
          minLimits: 0,
          errorText: "",
          required: false,
        };
        break;
      case "Email":
        newQuestion = {
          id: `item-${uuidv4()}`,
          question: "Email",
          type: "Email",
          required: false,
          sublabel: "",
          placeHolder: "",
          domainValidation: "",
          characterlimit: "",
          maxWords: 0,
          errorText: "",
        };
        break;
      case "Dropdown":
        newQuestion = {
          id: `item-${uuidv4()}`,
          type: "Dropdown",
          question: "DropDown QUestion",
          options: [
            { id: `item-${uuidv4()}`, optionText: "Chennai" },
            { id: `item-${uuidv4()}`, optionText: "Erode" },
            { id: `item-${uuidv4()}`, optionText: "Coimbatore" },
            { id: `item-${uuidv4()}`, optionText: "Madurai" },
          ],
          required: false,
        };
        break;
      case "Number":
        newQuestion = {
          id: `item-${uuidv4()}`,
          type: "Number",
          question: "Farmer ID number",
          answer: "",
          required: false,
          placeHolder: "",
          sublabel: "",
          errorText: "",
          minNumber: "",
          maxNumber: "",
          unit: "",
          placementUnit: "",
        };
        break;
      case "Line Scale":
        newQuestion = {
          id: `item-${uuidv4()}`,
          question: "Who is best PM of India in history",
          type: "Line Scale",
          sublabel: "",
          minValue: "",
          maxValue: "",
          placeholderMin: "Enter left label",
          placeholderMax: "Enter right label",
          minRange: { value: 0, labelName: "" },
          maxRange: { value: 5, labelName: "" },
          required: false,
        };
        break;
      case "Date":
        newQuestion = {
          id: `item-${uuidv4()}`,
          type: "Date",
          question: "Date",
          answer: "",
          sublable: "",
          autofillDate: false,
          required: false,
          dateFormat: "",
        };
        break;
      case "Multiple Choice grid":
        newQuestion = {
          id: `item-${uuidv4()}`,
          type: "Multiple Choice grid",
          question: "",
          row: [{ id: uuidv4(), rowText: "Row 1" }],
          column: [{ id: uuidv4(), columnText: "Column 1" }],
          sublable: "",
          required: false,
        };
        break;
      case "Check box grid":
        newQuestion = {
          id: `item-${uuidv4()}`,
          type: "Check box grid",
          question: "",
          required: false,
          row: [{ id: uuidv4(), rowText: "Row 1" }],
          column: [{ id: uuidv4(), columnText: "Column 1" }],
        };
        break;

      case "Website":
        newQuestion = {
          id: `item-${uuidv4()}`,
          question: "Website",
          answer: "",
          type: "Website",
          required: false,
          placeHolder: "Website link",
        };
        break;

      case "Spinner":
        newQuestion = {
          id: `item-${uuidv4()}`,
          type: "Spinner",
          question: "Spinner",
          sublabel: "",
          minValue: 0,
          maxValue: 100,
          intervalAmount: 1,
          required: false,
        };
        break;
      case "Signature":
        newQuestion = {
          id: `item-${uuidv4()}`,
          type: "Signature",
          question: "Signature",
          answer: "",
          required: false,
          sublabel: "",
          boxWidth: "",
          boxHeight: "",
        };
        break;
      case "File Upload":
        newQuestion = {
          id: `item-${uuidv4()}`,
          type: "File Upload",
          question: "File Upload",
          required: false,
          sublabel: "",
          fileSizeMin: "",
          fileSizeMax: "",
          NoOfNumFile: "",
          fileTypes: [],
        };
        break;
      case "Audio/Video Upload":
        newQuestion = {
          id: `item-${uuidv4()}`,
          type: "Audio/Video Upload",
          question: "Audio&Video FileUpload",
          required: false,
          sublabel: "",
          mediaType: "Audio",
          uploadMinLimt: "",
          uploadMaxLimt: "",
          fileSizeMax: "",
          fileSizeMin: "",
          fileTypes: [],
        };
        break;
      case "Section":
        newQuestion = {
          type: "Section",
        };
        break;
      case "Location":
        newQuestion = {
          id: `item-${uuidv4()}`,
          type: "Location",
          question: "Location",
          sublable: "",
          required: false,
          errorText: "",
          address: [
            { type: "address", placeHolder: "address line1", optionText: "" },
            { type: "address", placeHolder: "address line2", optionText: "" },
            { type: "text", placeHolder: "city", optionText: "" },
            { type: "text", placeHolder: "postal/zip code", optionText: "" },
            {
              type: "text",
              placeHolder: "state/region/province",
              optionText: "",
            },
            { type: "text", placeHolder: "country", optionText: "" },
          ],
        };
        break;
      case "Date - Time":
        newQuestion = {
          id: `item-${uuidv4()}`,
          type: "Date - Time",
          question: "",
          answer: "",
          sublable: "",
          required: false,
          dateFormat: "",
          timeformat: "",
        };
        break;
      default:
        break;
    }
    return newQuestion;
  };

  // Find item title
  const findItemTitle = (id) => {
    const container = findValueOfItems(id, "item");
    if (!container) return "";
    const item = container.questions.find((item) => item.id === id);
    if (!item) return "";
    return item;
  };

  // Find container title
  const findContainerTitle = (id) => {
    const container = findValueOfItems(id, "container");
    if (!container) return "";
    return container.title;
  };

  // Find container items
  const findContainerItems = (id) => {
    const container = findValueOfItems(id, "container");
    if (!container) return [];
    return container.items;
  };

  // DND Handlers
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  // Create colne question
  const colneQuestion = (type, overContainerIndex) => {
    const newItems = findquestion(type);
    // Find the index of the over container

    dispatch(createForm({ overContainerIndex, newItems }));
    setActiveQuestion(newItems.id);
  };

  // Create new section
  const createNewSections = (overContainerIndex, overItemIndex) => {
    dispatch(createNewSection({ overContainerIndex, overItemIndex }));
  };

  //FIND THE VALUE OF THE ITEMS
  function findValueOfItems(id, type) {
    if (type === "container") {
      return form?.sections.find((item) => item.id === id);
    }
    if (type === "item") {
      return form?.sections.find((container) =>
        container.questions.find((item) => item.id === id)
      );
    }
  }

  //HANDLE DRAG START
  function handleDragStart(event) {
    const { active } = event;

    const { id } = active;
    setActiveId(id);
  }

  //HANDLE DRAG MOVE
  const handleDragMove = (event) => {
    const { active, over } = event;

    // Handle Question option Sorting
    if (
      active.id.toString().includes("option") &&
      over &&
      over.id.toString().includes("option") &&
      active &&
      over &&
      active.id !== over.id
    ) {
      console.log(active);
    }
    // Handle Items Sorting
    if (
      active.id.toString().includes("item") &&
      over &&
      over.id.toString().includes("item") &&
      active &&
      over &&
      active.id !== over.id
    ) {
      // Find the active container and over container
      const activeContainer = findValueOfItems(active.id, "item");
      const overContainer = findValueOfItems(over.id, "item");

      // If the active or over container is not found, return
      if (!activeContainer || !overContainer) return;

      // Find the index of the active and over container
      const activeContainerIndex = form?.sections.findIndex(
        (container) => container.id === activeContainer.id
      );
      const overContainerIndex = form?.sections.findIndex(
        (container) => container.id === overContainer.id
      );

      // Find the index of the active and over item
      const activeitemIndex = activeContainer.questions.findIndex(
        (item) => item.id === active.id
      );
      const overitemIndex = overContainer.questions.findIndex(
        (item) => item.id === over.id
      );

      // In the same container
      if (activeContainerIndex === overContainerIndex) {
        dispatch(
          QuestionDnd({ activeitemIndex, overitemIndex, activeContainerIndex })
        );
      } else {
        // In different form
        dispatch(
          MoveQuestion({
            activeContainerIndex,
            overContainerIndex,
            overitemIndex,
            activeitemIndex,
          })
        );
      }
    }

    // Handling Item Drop Into a Container
    if (
      active.id.toString().includes("item") &&
      over &&
      over.id.toString().includes("container") &&
      active &&
      over &&
      active.id !== over.id
    ) {
      // Find the active and over container
      const activeContainer = findValueOfItems(active.id, "item");
      const overContainer = findValueOfItems(over.id, "container");

      // If the active or over container is not found, return
      if (!activeContainer || !overContainer) return;

      // Find the index of the active and over container
      const activeContainerIndex = form?.sections.findIndex(
        (container) => container.id === activeContainer.id
      );
      const overContainerIndex = form?.sections.findIndex(
        (container) => container.id === overContainer.id
      );

      // Find the index of the active item
      const activeitemIndex = activeContainer.questions.findIndex(
        (item) => item.id === active.id
      );

      dispatch(
        emptysectionmove({
          activeContainerIndex,
          overContainerIndex,
          activeitemIndex,
        })
      );
    }
    // Check if the dragged item is a text item and it's being dragged over another item
    if (
      active.id.toString().includes("text") &&
      over &&
      over.id.toString().includes("item") &&
      active &&
      over &&
      active.id !== over.id
    ) {
      // Set the ID of the item being dragged over
      setDraggedOverItemId(over.id);
    } else {
      // Reset the draggedOverItemId if not dragging over an item
      setDraggedOverItemId(null);
    }
  };

  //HANDLE DRAG END
  function handleDragEnd(event) {
    const { active, over } = event;
    console.log(active, over);
    // Handling Container Sorting
    if (
      active.id.toString().includes("container") &&
      over &&
      over.id.toString().includes("container") &&
      active &&
      over &&
      active.id !== over.id
    ) {
      // Find the index of the active and over container
      const activeContainerIndex = form.findIndex(
        (container) => container.id === active.id
      );
      const overContainerIndex = form.findIndex(
        (container) => container.id === over.id
      );
      setActiveQuestion(null);
      dispatch(sectionDnd({ activeContainerIndex, overContainerIndex }));
    }

    // Handling item Sorting
    if (
      active.id.toString().includes("item") &&
      over &&
      over.id.toString().includes("item") &&
      active &&
      over &&
      active.id !== over.id
    ) {
      // Find the active and over container
      const activeContainer = findValueOfItems(active.id, "item");
      const overContainer = findValueOfItems(over.id, "item");

      // If the active or over container is not found, return
      if (!activeContainer || !overContainer) return;
      // Find the index of the active and over container
      const activeContainerIndex = form.findIndex(
        (container) => container.id === activeContainer.id
      );
      const overContainerIndex = form.findIndex(
        (container) => container.id === overContainer.id
      );
      // Find the index of the active and over item
      const activeitemIndex = activeContainer.items.findIndex(
        (item) => item.id === active.id
      );
      const overitemIndex = overContainer.items.findIndex(
        (item) => item.id === over.id
      );

      // In the same container
      if (activeContainerIndex === overContainerIndex) {
        dispatch(
          QuestionDnd({ activeitemIndex, overitemIndex, activeContainerIndex })
        );
      } else {
        // In different form
        dispatch(
          MoveQuestion({
            activeContainerIndex,
            overContainerIndex,
            overitemIndex,
            activeitemIndex,
          })
        );
      }
    }

    // Handling item dropping into Container
    if (
      active.id.toString().includes("item") &&
      over &&
      over.id.toString().includes("container") &&
      active &&
      over &&
      active.id !== over.id
    ) {
      // Find the active and over container
      const activeContainer = findValueOfItems(active.id, "item");
      const overContainer = findValueOfItems(over.id, "container");

      // If the active or over container is not found, return
      if (!activeContainer || !overContainer) return;
      // Find the index of the active and over container
      const activeContainerIndex = form?.sections.findIndex(
        (container) => container.id === activeContainer.id
      );
      const overContainerIndex = form?.sections.findIndex(
        (container) => container.id === overContainer.id
      );
      // Find the index of the active and over item
      const activeitemIndex = activeContainer.questions.findIndex(
        (item) => item.id === active.id
      );

      dispatch(
        emptysectionmove({
          activeContainerIndex,
          overContainerIndex,
          activeitemIndex,
        })
      );
    }
    // Handling text item dropping into Container
    if (
      active.id.toString().includes("text") &&
      over &&
      active &&
      over &&
      active.id !== over.id
    ) {
      if (over.id.toString().includes("container")) {
        // Find the over container
        const overContainer = findValueOfItems(over.id, "container");

        // If the over container is not found, return
        if (!overContainer) return;

        // Find the index of the over container
        const overContainerIndex = form?.sections.findIndex(
          (container) => container.id === overContainer.id
        );

        // Find the text item
        const textItem = textItems.find((text) => text.id === active.id);

        if (!textItem) return;

        // Add the text item to the over container
        let newItems = findquestion(active.data.current.text);

        dispatch(createForm({ overContainerIndex, newItems }));
        setActiveQuestion(newItems.id);

        setActiveContainerIndex(overContainerIndex);
      } else if (over.id.toString().includes("item")) {
        // Find the over container
        const overContainer = findValueOfItems(over.id, "item");
        // If the over container is not found, return
        if (!overContainer) return;

        // Find the index of the over container
        const overContainerIndex = form?.sections.findIndex(
          (container) => container.id === overContainer.id
        );

        // Find the index where the text item was dropped within the container
        const overItemIndex = overContainer.questions.findIndex(
          (item) => item.id === over.id
        );

        // Find the text item
        const textItem = textItems.find((text) => text.id === active.id);

        if (!textItem) return;

        //   Add the text item to the over container at the determined position
        let newItems = findquestion(active.data.current.text);
        if (newItems.type === "Section") {
          dispatch(createNewSection({ overContainerIndex, overItemIndex }));
        } else {
          dispatch(
            updateFormOverQuestion({
              overContainerIndex,
              overItemIndex,
              newItems,
            })
          );
        }

        setActiveQuestion(newItems.id);
        setActiveContainerIndex(overContainerIndex);
        setDraggedOverItemId(null);
      }
    }
  }

  return (
    <div>
      <div>
        <ShearModel />
        <SelectTag
          isOpen={isTagSelectionOpen}
          onClose={closeTagSelectionModal}
          tags={form?.formTag}
          allTags={all_tags}
          onCreateTag={openCreateTagModal}
        />
        <Addtag
          isOpen={isCreateTagOpen}
          cancel={cancelTagAddModel}
          createTag={createTag}
        />
        <MoveSectionModel
          isOpen={isSectionMoveModal}
          onClose={handelCloseSectionModal}
        />
      </div>
      <div className="flex-container">
        <DndContext
          sensors={sensors}
          collisionDetection={closestCorners}
          onDragStart={handleDragStart}
          onDragMove={handleDragMove}
          onDragEnd={handleDragEnd}
        >
          <div className="component">
            <div
              style={{
                width: "80%",
              }}
            >
              <div className="form-title-text">
                <input
                  value={form?.formTitle}
                  onChange={(e) =>
                    dispatch(updateFormTitle({ value: e.target.value }))
                  }
                />
                <div className="all_tags">
                  {/* <Tags tag={tag} /> */}

                  {form?.formTag?.length > 0 && (
                    <>
                      {form?.formTag?.map((tag, index) => (
                        <div
                          style={{
                            color: tag.tagColor,
                            backgroundColor: hexToRGBA(tag.tagColor, 0.1),
                          }}
                          key={index}
                          className="tagText"
                          onMouseOver={() => setTagHoverIdx(index)}
                          onMouseLeave={() => setTagHoverIdx(null)}
                        >
                          {tag.tagIcon && (
                            <div style={{ textAlign: "center" }}>
                              {React.createElement(FaIcons[tag.tagIcon], {
                                size: 25,
                                style: { color: tag.tagColor, padding: "5px" },
                              })}
                            </div>
                          )}
                          {tag.tagName}
                          {tagHoveIdx === index && (
                            <img
                              src={tagCloseIcon}
                              alt="close"
                              onClick={() => handelRemoveTag(index)}
                            />
                          )}
                        </div>
                      ))}
                    </>
                  )}
                  <div
                    className="add_teg_btn tagText"
                    onClick={openTagSelectionModal}
                  >
                    <IoIosAddCircleOutline
                      style={{ fontSize: "16px", color: "#8493B2" }}
                    />
                    Add Tag
                  </div>
                </div>
              </div>
            </div>
            <SortableContext items={form?.sections.map((i) => i.id)}>
              {form?.sections.map((container, cindex) => (
                <Container
                  id={container.id}
                  title={container}
                  key={container._id}
                  onAddItem={() => {
                    setCurrentContainerId(container.id);
                  }}
                  sectionIndex={cindex}
                  activeContainerIndex={cindex}
                  sectionLength={form?.sections.length}
                  tags={form?.formTag}
                  generalSettings={form.generalSettings}
                >
                  <SortableContext items={container.questions.map((i) => i.id)}>
                    {container.questions.length > 0 &&
                      container.questions.map((i, index) => (
                        <div key={index}>
                          <Items
                            question={i}
                            id={i.id}
                            key={i.id}
                            questionIndex={index}
                            containerIndex={cindex}
                            colneQuestion={colneQuestion}
                            createNewSection={createNewSections}
                            generalSettings={form.generalSettings}
                          />
                        </div>
                      ))}
                  </SortableContext>
                </Container>
              ))}
            </SortableContext>
          </div>
          {openQuestionSetting ? (
            <NewComponent setOpenQuestionSetting={setOpenQuestionSetting} />
          ) : (
            <div className="text-container">
              <div className="text-container1">
                <SortableContext items={textItems.map((i) => i.id)}>
                  {textItems.map((i) => (
                    <TextComponent
                      key={i.id}
                      id={i.id}
                      text={i.text}
                      icon={i.icon}
                    />
                  ))}
                </SortableContext>
              </div>
            </div>
          )}
          <DragOverlay adjustScale={false}>
            {/* Drag Overlay For item Item */}
            {activeId && activeId.toString().includes("item") && (
              <Items id={activeId} question={findItemTitle(activeId)} />
            )}
            {/* Drag Overlay For Container */}
            {activeId && activeId.toString().includes("container") && (
              <Container id={activeId} title={findContainerTitle(activeId)}>
                {findContainerItems(activeId).map((i) => (
                  <Items key={i.id} question={i} id={i.id} />
                ))}
              </Container>
            )}
            {/* Drag Overlay For Text Items */}
            {activeId && activeId.toString().includes("text") && (
              <TextComponent
                id={activeId}
                text={textItems.find((t) => t.id === activeId)?.text}
                icon={textItems.find((t) => t.id === activeId)?.icon}
              />
            )}
          </DragOverlay>
        </DndContext>
      </div>
    </div>
  );
};

export default FormCreate;

function NewComponent({ setOpenQuestionSetting }) {
  const [moveRight, setMoveRight] = useState(false);
  const { activeQuestion, activeContainerIndex } = useContext(PageContext);
  console.log();
  const form = useSelector((state) => state.form.form);
  const [question] = form?.sections[activeContainerIndex].questions?.filter(
    (question) => question.id === activeQuestion
  );
  const questionIndex = form?.sections[activeContainerIndex].questions.findIndex(
    (question) => question.id === activeQuestion
  );
  const handleClick = () => {
    setMoveRight(true);
    setOpenQuestionSetting(false);
  };
  return (
    <div
      className={` text-container ${moveRight ? "move-right" : "slide-in"}`}
      style={{ padding: "1.8rem" }}
    >
      <div style={{ width: "100%", height: "100%" }}>
        {renderQuestionProperties(
          question,
          handleClick,
          activeContainerIndex,
          questionIndex
        )}
      </div>
    </div>
  );
}

const renderQuestionProperties = (
  question,
  handleClick,
  activeContainerIndex,
  questionIndex
) => {
  switch (question.type) {
    case "Short Answer":
      return (
        <ShortTextProperties
          handleClick={handleClick}
          question={question}
          containerIndex={activeContainerIndex}
          questionIndex={questionIndex}
        />
      );
    case "Name":
      return (
        <NamePro
          handleClick={handleClick}
          question={question}
          containerIndex={activeContainerIndex}
          questionIndex={questionIndex}
        />
      );
    case "Paragraph":
      return (
        <ParagraphQuestionProperties
          handleClick={handleClick}
          question={question}
          containerIndex={activeContainerIndex}
          questionIndex={questionIndex}
        />
      );
    case "Phone":
      return (
        <PhonePro
          handleClick={handleClick}
          question={question}
          containerIndex={activeContainerIndex}
          questionIndex={questionIndex}
        />
      );
    case "Multiple Choice":
      return (
        <MultipleChoicePro
          handleClick={handleClick}
          question={question}
          containerIndex={activeContainerIndex}
          questionIndex={questionIndex}
        />
      );
    case "Check box":
      return (
        <CheckBoxPro
          handleClick={handleClick}
          question={question}
          containerIndex={activeContainerIndex}
          questionIndex={questionIndex}
        />
      );
    case "Email":
      return (
        <EmailPro
          handleClick={handleClick}
          question={question}
          containerIndex={activeContainerIndex}
          questionIndex={questionIndex}
        />
      );
    case "Dropdown":
      return (
        <DropDownPro
          handleClick={handleClick}
          question={question}
          containerIndex={activeContainerIndex}
          questionIndex={questionIndex}
        />
      );
    case "Number":
      return (
        <NumberPro
          handleClick={handleClick}
          question={question}
          containerIndex={activeContainerIndex}
          questionIndex={questionIndex}
        />
      );
    case "Line Scale":
      return (
        <LineScalePro
          handleClick={handleClick}
          question={question}
          containerIndex={activeContainerIndex}
          questionIndex={questionIndex}
        />
      );

    case "Date":
      return (
        <DatePro
          handleClick={handleClick}
          question={question}
          containerIndex={activeContainerIndex}
          questionIndex={questionIndex}
        />
      );
    case "Multiple Choice grid":
      return (
        <MultipleChoiceGridPro
          handleClick={handleClick}
          question={question}
          containerIndex={activeContainerIndex}
          questionIndex={questionIndex}
        />
      );
    case "Check box grid":
      return (
        <CheckBoxGridPro
          handleClick={handleClick}
          question={question}
          containerIndex={activeContainerIndex}
          questionIndex={questionIndex}
        />
      );
    case "Website":
      return (
        <WebsitePro
          handleClick={handleClick}
          question={question}
          containerIndex={activeContainerIndex}
          questionIndex={questionIndex}
        />
      );
    case "Signature":
      return (
        <SignaturePro
          handleClick={handleClick}
          question={question}
          containerIndex={activeContainerIndex}
          questionIndex={questionIndex}
        />
      );
    case "Audio/Video Upload":
      return (
        <AVFileUploadPro
          handleClick={handleClick}
          question={question}
          containerIndex={activeContainerIndex}
          questionIndex={questionIndex}
        />
      );
    case "Spinner":
      return (
        <SpinnerPro
          handleClick={handleClick}
          question={question}
          containerIndex={activeContainerIndex}
          questionIndex={questionIndex}
        />
      );

    case "File Upload":
      return (
        <FileUploadPro
          handleClick={handleClick}
          question={question}
          containerIndex={activeContainerIndex}
          questionIndex={questionIndex}
        />
      );
    case "Date - Time":
      return (
        <DateTimePro
          handleClick={handleClick}
          question={question}
          containerIndex={activeContainerIndex}
          questionIndex={questionIndex}
        />
      );

    case "Location":
      return (
        <LocationPro
          handleClick={handleClick}
          question={question}
          containerIndex={activeContainerIndex}
          questionIndex={questionIndex}
        />
      );
    default:
      return null;
  }
};

const Option = ({
  option,
  handelOnchangeOption,
  deleteOption,
  addNewOption,
  optionIndex,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: option.id,
    data: {
      type: "address",
    },
  });
  return (
    <div
      ref={setNodeRef}
      {...attributes}
      style={{
        transition,
        transform: CSS.Translate.toString(transform),
      }}
      key={optionIndex}
      className="singleChoiceproOp"
    >
      <div className="properties-container-add">
        <p style={{ textWrap: "nowrap" }}>{option.placeHolder} : </p>
        <input
          className=""
          type="text"
          name="optionText"
          placeholder={option.placeHolder}
          value={option.optionText}
          onChange={(e) => handelOnchangeOption(e.target.value, optionIndex)}
        />
      </div>
    </div>
  );
};
const LocationPro = ({
  handleClick,
  question,
  containerIndex,
  questionIndex,
}) => {
  const dispatch = useDispatch();
  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  const handleChangeProp = (e, containerIndex) => {
    if (e.name === "character") {
      const { name, value } = e;

      dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
    } else {
      const { name, value } = e.target;
      dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
    }
  };
  const handelOnchangeOption = (address, optionIndex) => {
    dispatch(
      updateSingleChoiceOp({
        optionIndex,
        questionIndex,
        containerIndex,
        option: address,
      })
    );
  };

  const [isOpenAdvanc, setOpenAdvance] = useState(false);

  const selectionValue = [
    { check: "address line1", text: "Address line1" },
    { check: "address line2", text: "Address line2" },
    { check: "city", text: "City" },
    { check: "postal/zip code", text: "Postal / Zip Code" },
    { check: "state/region/province", text: "State/Region/Province" },
    { check: "country", text: "Country" },
  ];
  const handleCheckboxChange = (text, isChecked, index) => {
    if (isChecked) {
      dispatch(
        addAddress({
          index,
          text: text.toLowerCase(),
          containerIndex,
          questionIndex,
        })
      );
    } else {
      dispatch(
        removeAddress({
          index,
          text: text.toLowerCase(),
          containerIndex,
          questionIndex,
        })
      );
    }
  };
  return (
    <div className="questionContainer">
      <div className="propertiesTop">
        <p className="propertiesTitle">Location properties</p>
        <img
          src={propertiesCloseIcon}
          alt="propertiesCloseIcon"
          style={{ cursor: "pointer" }}
          onClick={handleClick}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Field label</p>
        <ReactQuill
          theme="snow"
          className="customs"
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Sub label</p>
        <textarea
          className="propertiesTextArea"
          value={question.sublabel}
          name="sublabel"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Address</p>
        <SortableContext items={question.address.map((i) => i.id)}>
          {question.address?.map((option, optionIndex) => {
            return (
              <Option
                option={option}
                handelOnchangeOption={handelOnchangeOption}
                // deleteOption={deleteOption}
                // addNewOption={addNewOption}
                optionIndex={optionIndex}
              />
            );
          })}
        </SortableContext>
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Error text </p>
        <input
          className="propertiesInput"
          value={question.errorText}
          placeholder="This is a required question"
          name="errorText"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <div
          className="propertiesText"
          onClick={() => setOpenAdvance(!isOpenAdvanc)}
        >
          <p>Advanced</p>
          <img
            src={isOpenAdvanc === false ? chevrondownl : chevronup}
            alt="chevron-down"
          />
        </div>
      </div>
      {isOpenAdvanc && (
        <div>
          <p className="propertiesText">Field option</p>
          <div>
            {selectionValue.map((value, i) => (
              <label className="custom-checkbox" key={i}>
                <input
                  type="checkbox"
                  name="option"
                  value={value.text}
                  // checked={(getAnswerValue(question._id) || []).includes(
                  //   option.optionText
                  // )}
                  checked={question.address.some((addr) =>
                    value.check.toLowerCase().includes(addr.placeHolder)
                  )}
                  onChange={(e) =>
                    handleCheckboxChange(value.check, e.target.checked, i)
                  }
                />
                <span className="custom-checkbox-mark"></span>
                {value.text}
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const ShortTextProperties = ({
  handleClick,
  question,
  containerIndex,
  questionIndex,
}) => {
  const dispatch = useDispatch();
  const handleQuestionChange = (newQuestion) => {
    console.log(newQuestion);
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  const handleChangeProp = (e, containerIndex) => {
    if (e.name === "character") {
      const { name, value } = e;

      dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
    } else {
      const { name, value } = e.target;
      dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
    }
  };
  const colourOptions = [
    { name: "character", value: "Any character", label: "Any character" },
    { name: "character", value: "Letters only", label: "Letters only" },
    { name: "character", value: "Letters number", label: "Letters number" },
    {
      name: "character",
      value: "Letters, number and spaces",
      label: "Letters, number and spaces",
    },
  ];

  const customStyles = {
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? "#E0E7F7" : "#fff",
      ":hover": {
        backgroundColor: "none",
      },
    }),
  };

  return (
    <div className="questionContainer">
      <div className="propertiesTop">
        <p className="propertiesTitle">Short text properties</p>
        <img
          src={propertiesCloseIcon}
          alt="propertiesCloseIcon"
          style={{ cursor: "pointer" }}
          onClick={handleClick}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Field label</p>
        <ReactQuill
          theme="snow"
          className="customs"
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Sub label</p>
        <textarea
          className="propertiesTextArea"
          value={question.sublabel}
          name="sublabel"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Place holder text</p>
        <input
          className="propertiesInput"
          value={question.placeHolder}
          name="placeHolder"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Character limit</p>
        <div className="Characterlimit">
          <input
            className="propertiesInput"
            value={question.minWords}
            name="minWords"
            type="number"
            onChange={(e) => handleChangeProp(e, containerIndex)}
          />
          <input
            className="propertiesInput"
            value="50"
            name="maxWords"
            type="number"
          />
        </div>
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Input Character</p>
        {console.log(question.character)}
        <Select
          className="basic-single"
          styles={customStyles}
          value={colourOptions.find(
            (option) => option.value === question.character
          )}
          name="character"
          options={colourOptions}
          // isClearable
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Error text </p>
        <input
          className="propertiesInput"
          value={question.errorText}
          placeholder="This is a required question"
          name="errorText"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
    </div>
  );
};

const NamePro = ({ handleClick, question, containerIndex, questionIndex }) => {
  const dispatch = useDispatch();
  const handleChangeProp = (e, containerIndex) => {
    const { name, value } = e.target;
    dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
  };
  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  return (
    <div className="questionContainer">
      <div className="propertiesTop">
        <p className="propertiesTitle">Short text properties</p>
        <img
          src={propertiesCloseIcon}
          alt="propertiesCloseIcon"
          style={{ cursor: "pointer" }}
          onClick={handleClick}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Field label</p>
        <ReactQuill
          theme="snow"
          className="customs"
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Sub label</p>
        <textarea
          className="propertiesTextArea"
          value={question.sublabel}
          name="sublabel"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="namePlaceHolder">
        <div className="nameInputContainer">
          <p className="name-value">First Name</p>
          <input
            value={question.firstName}
            name="firstName"
            onChange={(e) => handleChangeProp(e, containerIndex)}
          />
        </div>
        <div className="nameInputContainer">
          <p className="name-value">Last Name</p>
          <input
            value={question.lastName}
            name="lastName"
            onChange={(e) => handleChangeProp(e, containerIndex)}
          />
        </div>
      </div>
    </div>
  );
};

const ParagraphQuestionProperties = ({
  question,
  handleClick,
  containerIndex,
  questionIndex,
}) => {
  const dispatch = useDispatch();

  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };

  const handleChangeProp = (e, containerIndex) => {
    if (e.name === "character") {
      const { name, value } = e;
      dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
    } else {
      const { name, value } = e.target;
      dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
    }
  };

  const colourOptions = [
    { name: "character", value: " Any character", label: " Any character" },
    { name: "character", value: " Letters only", label: " Letters only" },
    { name: "character", value: "Letters number", label: "Letters number" },
    {
      name: "character",
      value: "Letters, number and spaces",
      label: "Letters, number and spaces",
    },
  ];
  const customStyles = {
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? "#E0E7F7" : "#fff",
      ":hover": {
        backgroundColor: "none",
      },
    }),
  };
  return (
    <div className="questionContainer">
      <div className="propertiesTop">
        <p className="propertiesTitle">Long text properties</p>
        <img
          src={propertiesCloseIcon}
          alt="propertiesCloseIcon"
          style={{ cursor: "pointer" }}
          onClick={handleClick}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Field label</p>
        <ReactQuill
          theme="snow"
          className="customs"
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Sub label</p>
        <textarea
          className="propertiesTextArea"
          value={question.sublabel}
          name="sublabel"
          placeholder="Sub label"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Place holder text</p>
        <input
          className="propertiesInput"
          value={question.placeHolder}
          name="placeHolder"
          placeholder="placeHolder"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Character limit</p>
        <div className="Characterlimit">
          <input
            className="propertiesInput"
            value={question.minWords}
            name="minWords"
            type="number"
            onChange={(e) => handleChangeProp(e, containerIndex)}
          />
          <input
            className="propertiesInput"
            value={question.maxWords}
            name="maxWords"
            type="number"
            onChange={(e) => handleChangeProp(e, containerIndex)}
          />
        </div>
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Input Character</p>
        <Select
          className="basic-single"
          classNamePrefix="select"
          styles={customStyles}
          onChange={(e) => handleChangeProp(e, containerIndex)}
          name="character"
          options={colourOptions}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Error text </p>
        <input
          className="propertiesInput"
          value={question.errorText}
          placeholder="This is a required question"
          name="errorText"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
    </div>
  );
};

const PhonePro = ({ handleClick, question, containerIndex, questionIndex }) => {
  const dispatch = useDispatch();
  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  const handleChangeProp = (e, containerIndex) => {
    const { name, value } = e.target;
    dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
  };
  return (
    <div className="questionContainer">
      <div className="propertiesTop">
        <p className="propertiesTitle">Phone properties</p>
        <img
          src={propertiesCloseIcon}
          alt="propertiesCloseIcon"
          style={{ cursor: "pointer" }}
          onClick={handleClick}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Field label</p>
        <ReactQuill
          theme="snow"
          className="customs"
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Sub label</p>
        <textarea
          className="propertiesTextArea"
          value={question.sublabel}
          name="sublabel"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Place holder text</p>
        <input
          className="propertiesInput"
          value={question.placeHolder}
          name="placeHolder"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Error text </p>
        <input
          className="propertiesInput"
          value={question.errorText}
          placeholder="This is a required question"
          name="errorText"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
    </div>
  );
};

const MultipleChoicePro = ({
  containerIndex,
  questionIndex,
  question,
  handleClick,
}) => {
  const dispatch = useDispatch();
  const handleChangeProp = (e, containerIndex) => {
    const { name, value } = e.target;
    dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
  };

  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  const handelOnchangeOption = (option, optionIndex) => {
    dispatch(
      updateSingleChoiceOp({
        optionIndex,
        questionIndex,
        containerIndex,
        option,
      })
    );
  };
  const addNewOption = (optionIndex) => {
    dispatch(
      addOptionSingleChoiceopPro({ optionIndex, questionIndex, containerIndex })
    );
  };
  const deleteOption = (optionIndex) => {
    dispatch(
      deleteSingleChoiseOption({ optionIndex, questionIndex, containerIndex })
    );
  };

  const colourOptions = [
    { label: "None ", value: "None" },
    { label: "Day", value: "Day" },
    { label: "Month", value: "Month" },
    { label: "Gender", value: "Gender" },
  ];

  const customStyles = {
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? "#E0E7F7" : "#fff",
      ":hover": {
        backgroundColor: "none",
      },
    }),
  };

  const findOption = (type) => {
    let newQuestion;
    switch (type) {
      case "Gender":
        newQuestion = ["Male", "Female", "N/A"];
        break;
      case "Day":
        newQuestion = [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ];
        break;
      case "Month":
        newQuestion = [
          "January",
          "Feburuary",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        break;
      case "None":
        newQuestion = ["Type Option 1", "Type Option 2"];
        break;
      default:
        break;
    }
    return newQuestion;
  };

  const handleUpdateOption = (optionValue) => {
    const optionLength = question.options.length;
    const selectedOption = findOption(optionValue.value);
    dispatch(
      updateOpton({
        optionLength,
        selectedOption,
        questionIndex,
        containerIndex,
      })
    );
  };

  return (
    <div className="questionContainer">
      <div className="propertiesTop">
        <p className="propertiesTitle">Single choice properties</p>
        <img
          src={propertiesCloseIcon}
          alt="propertiesCloseIcon"
          style={{ cursor: "pointer" }}
          onClick={handleClick}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Field label</p>
        <ReactQuill
          theme="snow"
          className="customs"
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Sub label</p>
        <textarea
          className="propertiesTextArea"
          value={question.sublabel}
          name="sublabel"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Choices</p>
        <SortableContext items={question.options.map((i) => i.id)}>
          {question.options.map((option, optionIndex) => {
            return (
              <OPtion
                option={option}
                handelOnchangeOption={handelOnchangeOption}
                deleteOption={deleteOption}
                addNewOption={addNewOption}
                optionIndex={optionIndex}
              />
            );
          })}
        </SortableContext>
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Predefined option</p>
        <Select
          className="basic-single"
          styles={customStyles}
          onChange={(e) => handleUpdateOption(e)}
          name="character"
          options={colourOptions}
        />
        <p className="ready-made-optiontext">
          Select a ready-made list of option (Day, month, etc..)
        </p>
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Error text </p>
        <input
          className="propertiesInput"
          value={question.errorText}
          placeholder="This is a required question"
          name="errorText"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
    </div>
  );
};

const OPtion = ({
  option,
  handelOnchangeOption,
  deleteOption,
  addNewOption,
  optionIndex,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: option.id,
    data: {
      type: "option",
    },
  });
  return (
    <div
      ref={setNodeRef}
      {...attributes}
      style={{
        transition,
        transform: CSS.Translate.toString(transform),
      }}
      key={option.id}
      className="singleChoiceproOp"
    >
      <img src={singleCProDndIcon} alt="dndicon" {...listeners} />
      <input
        className="propertiesInput"
        value={option.optionText}
        onChange={(e) => handelOnchangeOption(e.target.value, optionIndex)}
      />
      <img
        src={singleCProDeleteIcon}
        alt="deleteIcon"
        style={{ cursor: "pointer" }}
        onClick={() => {
          deleteOption(optionIndex);
        }}
      />
      <img
        src={singleCProAddIcon}
        alt="addIcon"
        style={{ cursor: "pointer" }}
        onClick={() => {
          addNewOption(optionIndex);
        }}
      />
    </div>
  );
};

const CheckBoxPro = ({
  handleClick,
  question,
  containerIndex,
  questionIndex,
}) => {
  const dispatch = useDispatch();

  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  const handleChangeProp = (e, containerIndex) => {
    const { name, value } = e.target;
    dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
  };
  const handelOnchangeOption = (option, optionIndex) => {
    dispatch(
      updateSingleChoiceOp({
        optionIndex,
        questionIndex,
        containerIndex,
        option,
      })
    );
  };
  const deleteOption = (optionIndex) => {
    dispatch(
      deleteSingleChoiseOption({ optionIndex, questionIndex, containerIndex })
    );
  };
  const addNewOption = (optionIndex) => {
    dispatch(
      addOptionSingleChoiceopPro({ optionIndex, questionIndex, containerIndex })
    );
  };

  return (
    <div className="questionContainer">
      <div className="propertiesTop">
        <p className="propertiesTitle">Check box</p>
        <img
          src={propertiesCloseIcon}
          alt="propertiesCloseIcon"
          style={{ cursor: "pointer" }}
          onClick={handleClick}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Field label</p>
        <ReactQuill
          theme="snow"
          className="customs"
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Sub label</p>
        <textarea
          className="propertiesTextArea"
          value={question.sublabel}
          name="sublabel"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Choices</p>
        {question.options.map((option, optionIndex) => {
          return (
            <div key={option.id} className="singleChoiceproOp">
              <img src={singleCProDndIcon} alt="dndicon" />
              <input
                className="propertiesInput"
                value={option.optionText}
                onChange={(e) =>
                  handelOnchangeOption(e.target.value, optionIndex)
                }
              />
              <img
                src={singleCProDeleteIcon}
                alt="deleteIcon"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  deleteOption(optionIndex);
                }}
              />
              <img
                src={singleCProAddIcon}
                alt="addIcon"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  addNewOption(optionIndex);
                }}
              />
            </div>
          );
        })}
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Character limit</p>
        <div className="Characterlimit">
          <input
            className="propertiesInput"
            value={question.minLimits}
            name="minLimits"
            type="number"
            onChange={(e) => handleChangeProp(e, containerIndex)}
          />
          <input
            className="propertiesInput"
            value={question.maxLimits}
            name="maxMints"
            type="number"
            onChange={(e) => handleChangeProp(e, containerIndex)}
          />
        </div>
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Error text </p>
        <input
          className="propertiesInput"
          value={question.errorText}
          placeholder="This is a required question"
          name="errorText"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
    </div>
  );
};

const EmailPro = ({ handleClick, question, containerIndex, questionIndex }) => {
  const dispatch = useDispatch();

  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  const handleChangeProp = (e, containerIndex) => {
    if (e.name === "Domain") {
      const { name, value } = e;
      dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
    } else {
      const { name, value } = e.target;
      dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
    }
  };

  const colourOptions = [
    {
      name: "Domain",
      value: "Allow every domain",
      label: " Allow every domain",
    },
    {
      name: "Domain",
      value: "Allow particular domains",
      label: "Allow particular domains",
    },
    {
      name: "Domain",
      value: "Restricted domains",
      label: "Restricted domains",
    },
  ];
  const customStyles = {
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? "#E0E7F7" : "#fff",
      ":hover": {
        backgroundColor: "none",
      },
    }),
  };
  return (
    <div className="questionContainer">
      <div className="propertiesTop">
        <p className="propertiesTitle">Short text properties</p>
        <img
          src={propertiesCloseIcon}
          alt="propertiesCloseIcon"
          style={{ cursor: "pointer" }}
          onClick={handleClick}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Field label</p>
        <ReactQuill
          theme="snow"
          className="customs"
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Sub label</p>
        <textarea
          className="propertiesTextArea"
          value={question.sublabel}
          name="sublabel"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Place holder text</p>
        <input
          className="propertiesInput"
          value={question.placeHolder}
          name="placeHolder"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Domain validation</p>
        <Select
          className="basic-single"
          classNamePrefix="select"
          styles={customStyles}
          onChange={(e) => handleChangeProp(e, containerIndex)}
          name="character"
          options={colourOptions}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Error text </p>
        <input
          className="propertiesInput"
          value={question.errorText}
          placeholder="This is a required question"
          name="errorText"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="CharacterlimitEmail">
        <p className="propertiesText">Character limit</p>
        <input
          className="propertiesInput"
          value={question.minWords}
          placeholder="Max"
          type="number"
          name="maxWords"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
    </div>
  );
};

const NumberPro = ({
  handleClick,
  question,
  containerIndex,
  questionIndex,
}) => {
  const dispatch = useDispatch();
  const handleChangeProp = (e, containerIndex) => {
    const { name, value } = e.target;
    dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
  };

  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  return (
    <div className="questionContainer">
      <div className="propertiesTop">
        <p className="propertiesTitle">Number properties</p>
        <img
          src={propertiesCloseIcon}
          alt="propertiesCloseIcon"
          style={{ cursor: "pointer" }}
          onClick={handleClick}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Field label</p>
        <ReactQuill
          theme="snow"
          className="customs"
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Sub label</p>
        <textarea
          className="propertiesTextArea"
          value={question.sublabel}
          name="sublabel"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Placeholder text</p>
        <input
          className="propertiesInput"
          value={question.placeHolder}
          name="placeHolder"
          placeholder="placeHolder"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Character limit</p>
        <div className="Characterlimit">
          <input
            className="propertiesInput"
            value={question.minWords}
            name="minNumber"
            placeholder="Min"
            type="number"
            onChange={(e) => handleChangeProp(e, containerIndex)}
          />
          <input
            className="propertiesInput"
            value={question.maxNumber}
            name="maxNumber"
            type="number"
            placeholder="Max"
            onChange={(e) => handleChangeProp(e, containerIndex)}
          />
        </div>
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Unit</p>
        <input
          className="propertiesInput"
          value={question.unit}
          name="unit"
          placeholder="Unit"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Error text </p>
        <input
          className="propertiesInput"
          value={question.errorText}
          placeholder="This is a required question"
          name="errorText"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
    </div>
  );
};

const LineScalePro = ({
  handleClick,
  question,
  containerIndex,
  questionIndex,
}) => {
  const dispatch = useDispatch();
  const handleChangeProp = (e, containerIndex) => {
    const { name, value } = e.target;
    dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
  };
  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  return (
    <div className="questionContainer">
      <div className="propertiesTop">
        <p className="propertiesTitle">Line scale properties</p>
        <img
          src={propertiesCloseIcon}
          alt="propertiesCloseIcon"
          style={{ cursor: "pointer" }}
          onClick={handleClick}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Field label</p>
        <ReactQuill
          theme="snow"
          className="customs"
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Sub label</p>
        <textarea
          className="propertiesTextArea"
          value={question.sublabel}
          name="sublabel"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Left label </p>
        <input
          className="propertiesInput"
          value={question.minValue}
          placeholder="Answer"
          name="minValue"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Left label</p>
        <input
          className="propertiesInput"
          value={question.maxValue}
          placeholder="Answer"
          name="maxValue"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Character limit</p>
        <div className="Characterlimit">
          <input
            className="propertiesInput"
            value={question.minRange.value}
            name="minRange"
            type="number"
            onChange={(e) => handleChangeProp(e, containerIndex)}
          />
          <input
            className="propertiesInput"
            value={question.maxRange.value}
            name="maxRange"
            type="number"
          />
        </div>
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Error text </p>
        <input
          className="propertiesInput"
          value={question.errorText}
          placeholder="This is a required question"
          name="errorText"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
    </div>
  );
};

const DatePro = ({ handleClick, question, containerIndex, questionIndex }) => {
  const dispatch = useDispatch();
  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  const handleChangeProp = (e, containerIndex) => {
    console.log(e.name);
    if (e.name === "dateFormat") {
      const { name, value } = e;
      dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
    } else {
      const { name, value } = e.target;
      dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
    }
  };
  const colourOptions = [
    { name: "dateFormat", value: "MM - DD - YYYY", label: "MM - DD - YYYY" },
    { name: "dateFormat", value: "DD - MM - YYYY", label: "DD - MM - YYYY" },
    { name: "dateFormat", value: "YYYY - MM - DD", label: "YYYY - MM - DD" },
  ];

  const customStyles = {
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? "#1B51BB66" : "#fff",
      ":hover": {
        backgroundColor: "none",
      },
    }),
  };
  const handelAutoFill = (value, containerIndex) => {
    dispatch(updateDateAutoFill({ containerIndex, questionIndex, value }));
  };

  const options = [
    { value: "Mon", label: "Monday" },
    { value: "Tue", label: "Tuesday" },
    { value: "Wed", label: "Wednesday" },
    { value: "Thu", label: "Thursday" },
    { value: "Fri", label: "Friday" },
    { value: "Sat", label: "Saturday" },
    { value: "Sun", label: "Sunday" },
  ];
  // Custom Option component to include a checkbox
  const CheckboxOption = (props) => {
    return (
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null} // Prevents checkbox from being unchecked directly
        />{" "}
        <label>{props.label}</label>
      </components.Option>
    );
  };
  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleChange = (selected) => {
    setSelectedOptions(selected);
    const selectedNames = selected
      ? selected.map((option) => option.label)
      : [];
    console.log("Selected options:", selectedNames);
  };
  return (
    <div className="questionContainer">
      <div className="propertiesTop">
        <p className="propertiesTitle">Line scale properties</p>
        <img
          src={propertiesCloseIcon}
          alt="propertiesCloseIcon"
          style={{ cursor: "pointer" }}
          onClick={handleClick}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Field label</p>
        <ReactQuill
          theme="snow"
          className="customs"
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Input Character</p>
        <Select
          className="basic-single"
          styles={customStyles}
          onChange={(e) => handleChangeProp(e, containerIndex)}
          name="dateFormat"
          options={colourOptions}
          value={question.dateFormat}
        />
      </div>
      <div className="dateAutoFill">
        <input
          type="checkbox"
          className="dateCheck"
          value={question.autofillDate}
          name="autoFillDate"
          onChange={(e) => handelAutoFill(e.target.checked, containerIndex)}
        />
        <p className="propertiesText">Input Character</p>
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Input Character</p>
        <Select
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          styles={customStyles}
          components={{ Option: CheckboxOption }}
          options={options}
          value={selectedOptions}
          onChange={handleChange}
          placeholder="Select flavors"
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Error text </p>
        <input
          className="propertiesInput"
          value={question.errorText}
          placeholder="This is a required question"
          name="errorText"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
    </div>
  );
};

const MultipleChoiceGridPro = ({
  handleClick,
  question,
  containerIndex,
  questionIndex,
}) => {
  const dispatch = useDispatch();
  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  const handelOnchangeOption = (e, optionIndex) => {
    const { value, name } = e.target;
    dispatch(
      changeMultipleOption({
        value,
        optionIndex,
        containerIndex,
        questionIndex,
        name,
      })
    );
  };
  const deleteOption = (optionIndex, text) => {
    dispatch(
      deleteMultiChoice({ questionIndex, containerIndex, optionIndex, text })
    );
    // deleteSingleChoiseOption({ optionIndex, questionIndex, containerIndex })
  };
  const addOption = (text, length) => {
    dispatch(addMultiChoice({ text, containerIndex, questionIndex, length }));
  };
  const handleChangeProp = (e, containerIndex) => {
    const { name, value } = e.target;
    dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
  };
  return (
    <div className="questionContainer">
      <div className="propertiesTop">
        <p className="propertiesTitle">Multiple choice grid</p>
        <img
          src={propertiesCloseIcon}
          alt="propertiesCloseIcon"
          style={{ cursor: "pointer" }}
          onClick={handleClick}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Field label</p>
        <ReactQuill
          theme="snow"
          className="customs"
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Row</p>
        {question.row.map((option, optionIndex) => {
          return (
            <div key={option.id} className="singleChoiceproOp">
              <img src={singleCProDndIcon} alt="dndicon" />
              <input
                className="propertiesInput"
                value={option.rowText}
                name="rowText"
                onChange={(e) => handelOnchangeOption(e, optionIndex)}
              />
              <img
                src={singleCProDeleteIcon}
                alt="deleteIcon"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  deleteOption(optionIndex, "row");
                }}
              />
            </div>
          );
        })}
        <div
          className="addBtn-MultiGrid"
          onClick={() => addOption("row", question.row.length)}
        >
          <img src={addbtnmultiplegrid} alt="add-btn-multiple-grid" /> Add Row
        </div>
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Column</p>
        {question.column.map((option, optionIndex) => {
          return (
            <div key={option.id} className="singleChoiceproOp">
              <img src={singleCProDndIcon} alt="dndicon" />
              <input
                className="propertiesInput"
                value={option.columnText}
                name="columnText"
                onChange={(e) => handelOnchangeOption(e, optionIndex)}
              />
              <img
                src={singleCProDeleteIcon}
                alt="deleteIcon"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  deleteOption(optionIndex, "column");
                }}
              />
            </div>
          );
        })}
        <div
          className="addBtn-MultiGrid"
          onClick={() => addOption("column", question.column.length)}
        >
          <img src={addbtnmultiplegrid} alt="add-btn-multiple-grid" /> Add
          Column
        </div>
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Error text </p>
        <input
          className="propertiesInput"
          value={question.errorText}
          placeholder="This is a required question"
          name="errorText"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
    </div>
  );
};

const CheckBoxGridPro = ({
  handleClick,
  question,
  containerIndex,
  questionIndex,
}) => {
  const dispatch = useDispatch();
  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  const handelOnchangeOption = (e, optionIndex) => {
    const { value, name } = e.target;
    // console.log(value, name)
    dispatch(
      changeMultipleOption({
        value,
        optionIndex,
        containerIndex,
        questionIndex,
        name,
      })
    );
  };
  const deleteOption = (optionIndex, text) => {
    dispatch(
      deleteMultiChoice({ questionIndex, containerIndex, optionIndex, text })
    );
  };
  const addOption = (text, length) => {
    dispatch(addMultiChoice({ text, containerIndex, questionIndex, length }));
  };
  const handleChangeProp = (e, containerIndex) => {
    const { name, value } = e.target;
    dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
  };
  return (
    <div className="questionContainer">
      <div className="propertiesTop">
        <p className="propertiesTitle">Multiple choice grid</p>
        <img
          src={propertiesCloseIcon}
          alt="propertiesCloseIcon"
          style={{ cursor: "pointer" }}
          onClick={handleClick}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Field label</p>
        <ReactQuill
          theme="snow"
          className="customs"
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Row</p>
        {question.row.map((option, optionIndex) => {
          return (
            <div key={option.id} className="singleChoiceproOp">
              <img src={singleCProDndIcon} alt="dndicon" />
              <input
                className="propertiesInput"
                value={option.rowText}
                name="rowText"
                onChange={(e) => handelOnchangeOption(e, optionIndex)}
              />
              <img
                src={singleCProDeleteIcon}
                alt="deleteIcon"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  deleteOption(optionIndex, "row");
                }}
              />
            </div>
          );
        })}
        <div
          className="addBtn-MultiGrid"
          onClick={() => addOption("row", question.row.length)}
        >
          <img src={addbtnmultiplegrid} alt="add-btn-multiple-grid" /> Add Row
        </div>
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Column</p>
        {question.column.map((option, optionIndex) => {
          return (
            <div key={option.id} className="singleChoiceproOp">
              <img src={singleCProDndIcon} alt="dndicon" />
              <input
                className="propertiesInput"
                value={option.columnText}
                name="columnText"
                onChange={(e) => handelOnchangeOption(e, optionIndex)}
              />
              <img
                src={singleCProDeleteIcon}
                alt="deleteIcon"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  deleteOption(optionIndex, "column");
                }}
              />
            </div>
          );
        })}
        <div
          className="addBtn-MultiGrid"
          onClick={() => addOption("column", question.column.length)}
        >
          <img src={addbtnmultiplegrid} alt="add-btn-multiple-grid" /> Add
          Column
        </div>
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Error text </p>
        <input
          className="propertiesInput"
          value={question.errorText}
          placeholder="This is a required question"
          name="errorText"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
    </div>
  );
};

const WebsitePro = ({
  handleClick,
  question,
  containerIndex,
  questionIndex,
}) => {
  const dispatch = useDispatch();
  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  const handleChangeProp = (e, containerIndex) => {
    const { name, value } = e.target;
    dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
  };
  return (
    <div className="questionContainer">
      <div className="propertiesTop">
        <p className="propertiesTitle">Website properties</p>
        <img
          src={propertiesCloseIcon}
          alt="propertiesCloseIcon"
          style={{ cursor: "pointer" }}
          onClick={handleClick}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Field label</p>
        <ReactQuill
          theme="snow"
          className="customs"
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Sub label</p>
        <textarea
          className="propertiesTextArea"
          value={question.sublabel}
          name="sublabel"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Place holder text</p>
        <input
          className="propertiesInput"
          value={question.placeHolder}
          name="placeHolder"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Error text </p>
        <input
          className="propertiesInput"
          value={question.errorText}
          placeholder="This is a required question"
          name="errorText"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
    </div>
  );
};

const SignaturePro = ({
  question,
  handleClick,
  containerIndex,
  questionIndex,
}) => {
  const dispatch = useDispatch();
  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  const handleChangeProp = (e, containerIndex) => {
    const { name, value } = e.target;
    dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
  };
  return (
    <div className="questionContainer">
      <div className="propertiesTop">
        <p className="propertiesTitle">Signature properties</p>
        <img
          src={propertiesCloseIcon}
          alt="propertiesCloseIcon"
          style={{ cursor: "pointer" }}
          onClick={handleClick}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Field label</p>
        <ReactQuill
          theme="snow"
          className="customs"
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Sub label</p>
        <textarea
          className="propertiesTextArea"
          value={question.sublabel}
          name="sublabel"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Box Width</p>
        <input
          className="propertiesInputN"
          value={question.intervelAmount}
          placeholder="00"
          name="boxWidth"
          type="number"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Box height</p>
        <input
          className="propertiesInputN"
          value={question.intervelAmount}
          placeholder="00"
          name="boxHeight"
          type="number"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Error text </p>
        <input
          className="propertiesInput"
          value={question.errorText}
          placeholder="This is a required question"
          name="errorText"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
    </div>
  );
};

const AVFileUploadPro = ({
  handleClick,
  question,
  containerIndex,
  questionIndex,
}) => {
  const dispatch = useDispatch();
  const handleChangeProp = (e, containerIndex) => {
    if (e.name === "mediaType") {
      const { name, value } = e;
      dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
    } else {
      const { name, value } = e.target;
      dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
    }
  };
  const handelChange = (e, containerIndex) => {
    const { name, value } = e;
    dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
  };
  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  const [fileFormats, setFileFormats] = useState([
    { id: uuidv4(), name: "mp3", selected: false },
    { id: uuidv4(), name: "WAV", selected: false },
    { id: uuidv4(), name: "AAC", selected: false },
    { id: uuidv4(), name: "FLAC", selected: false },
    { id: uuidv4(), name: "OGG", selected: false },
    { id: uuidv4(), name: "AIFF", selected: false },
  ]);
  const [videoFileFormats, setVideoFileFormats] = useState([
    { id: uuidv4(), name: "MP4", selected: false },
    { id: uuidv4(), name: "AVI", selected: false },
    { id: uuidv4(), name: "AVI", selected: false },
    { id: uuidv4(), name: "WMV", selected: false },
    { id: uuidv4(), name: "MKV", selected: false },
    { id: uuidv4(), name: "WebM", selected: false },
  ]);

  const [show, setShow] = useState(false);

  const handelSingleCheckBox = (id) => {
    const checkedFileFormat = fileFormats.map((file) =>
      file.id === id ? { ...file, selected: !file.selected } : file
    );
    setFileFormats(checkedFileFormat);
    const checkedValue = checkedFileFormat
      .filter((value) => value.selected === true)
      .map((item) => item.name);
    dispatch(
      updateFileTypes({
        containerIndex,
        questionIndex,
        checkedFileFormat: checkedValue,
      })
    );
  };

  const handelAllSelected = (e) => {
    const checked = e.target.checked;
    const allSelected = fileFormats.map((file) => ({
      ...file,
      selected: checked,
    }));
    setFileFormats(allSelected);
  };

  const colourOptions = [
    {
      name: "mediaType",
      value: "Audio",
      label: "Audio",
    },
    {
      name: "mediaType",
      value: "Video",
      label: "Video",
    },
  ];
  const limitmin = [
    {
      name: "uploadMinLimt",
      value: "0",
      label: "0",
    },
    {
      name: "uploadMinLimt",
      value: "1",
      label: "1",
    },
    {
      name: "uploadMinLimt",
      value: "2",
      label: "2",
    },
    {
      name: "uploadMinLimt",
      value: "3",
      label: "3",
    },
  ];
  const limitmax = [
    {
      name: "uploadMaxLimt",
      value: "2",
      label: "2",
    },
    {
      name: "uploadMaxLimt",
      value: "3",
      label: "3",
    },
    {
      name: "uploadMaxLimt",
      value: "4",
      label: "4",
    },
    {
      name: "uploadMaxLimt",
      value: "5",
      label: "5",
    },
  ];

  const customStyles = {
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? "#E0E7F7" : "#fff",
      ":hover": {
        backgroundColor: "none",
      },
    }),
  };
  return (
    <div className="questionContainer">
      <div className="propertiesTop">
        <p className="propertiesTitle">File upload properties</p>
        <img
          src={propertiesCloseIcon}
          alt="propertiesCloseIcon"
          style={{ cursor: "pointer" }}
          onClick={handleClick}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Field label</p>
        <ReactQuill
          theme="snow"
          className="customs"
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Sub label</p>
        <textarea
          className="propertiesTextArea"
          value={question.sublabel}
          name="sublabel"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Media Type</p>
        <Select
          className="basic-single"
          styles={customStyles}
          onChange={(e) => handelChange(e, containerIndex)}
          name="character"
          options={colourOptions}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Upload limit</p>
        <div className="fileUploadContainer">
          <div className="upload_container">
            <Select
              className="basic-single"
              styles={customStyles}
              onChange={(e) => handelChange(e, containerIndex)}
              name="uploadMinLimt"
              options={limitmin}
            />
          </div>
          <div className="upload_container">
            <Select
              className="basic-single"
              styles={customStyles}
              onChange={(e) => handelChange(e, containerIndex)}
              name="uploadMaxLimt"
              options={limitmax}
            />
          </div>
        </div>
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Limit file size</p>
        <div className="fileUploadContainer">
          <div className="inputContainer">
            <input
              className="filePropertiesInput"
              name="fileSizeMin"
              type="number"
              value={question.fileSizeMin}
              onChange={(e) => handleChangeProp(e, containerIndex)}
            />
            <p style={{ color: "#D3DCE5" }}>|</p>
            <select>
              <option>KB</option>
              <option>MB</option>
            </select>
          </div>
          <div className="inputContainer">
            <input
              className="filePropertiesInput"
              name="fileSizeMax"
              type="number"
              value={question.fileSizeMax}
              onChange={(e) => handleChangeProp(e, containerIndex)}
            />
            <p style={{ color: "#D3DCE5" }}>|</p>
            <select>
              <option>KB</option>
              <option>MB</option>
            </select>
          </div>
        </div>
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Input Character</p>
        <div className="Custom-audio-container" onClick={() => setShow(!show)}>
          Custom audio type
        </div>
        {show && (
          <div className="custom-select-below">
            <div className="custom-box-abu">
              <input type="checkbox" onChange={(e) => handelAllSelected(e)} />
              Select all
            </div>
            {fileFormats.map((item, id) => {
              return (
                <div className="custom-box-abu">
                  <input
                    type="checkbox"
                    checked={item.selected}
                    onChange={() => {
                      handelSingleCheckBox(item.id);
                    }}
                  />
                  {item.name}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};
const FileUploadPro = ({
  question,
  handleClick,
  containerIndex,
  questionIndex,
}) => {
  const dispatch = useDispatch();
  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };

  const handleChangeProp = (e, containerIndex) => {
    const { name, value } = e.target;
    // if (name === "NoOfNumFile") {
    //   const nameValue = parseInt(value);
    //   dispatch(
    //     updatevalueFrom({
    //       name,
    //       value: nameValue,
    //       containerIndex,
    //       questionIndex,
    //     })
    //   );
    // } else {
    dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
    // }
  };

  return (
    <div className="questionContainer">
      <div className="propertiesTop">
        <p className="propertiesTitle">File upload properties</p>
        <img
          src={propertiesCloseIcon}
          alt="propertiesCloseIcon"
          style={{ cursor: "pointer" }}
          onClick={handleClick}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Field label</p>
        <ReactQuill
          theme="snow"
          className="customs"
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Sub label</p>
        <textarea
          className="propertiesTextArea"
          value={question.sublabel}
          name="sublabel"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Limit file size</p>
        <div className="fileUploadContainer">
          <div className="inputContainer">
            <input
              className="filePropertiesInput"
              name="fileSizeMin"
              type="number"
              value={question.fileSizeMin}
              onChange={(e) => handleChangeProp(e, containerIndex)}
            />
            |<p>KB</p>
          </div>
          <div className="inputContainer">
            <input
              className="filePropertiesInput"
              name="fileSizeMax"
              type="number"
              value={question.fileSizeMax}
              onChange={(e) => handleChangeProp(e, containerIndex)}
            />
            |<p>KB</p>
          </div>
        </div>
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Limit number of files</p>
        <input
          className="propertiesInputN"
          value={question.NoOfNumFile}
          name="NoOfNumFile"
          type="number"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">File types</p>
        <textarea
          className="propertiesTextArea"
          value={question.fileTypes}
          name="fileTypes"
          placeholder="pdf, doc, docx, xls, xlsx, csv, txt, rtf, html, zip, mp3, wma, mpg, flv, avi, jpg, jpeg, png, gif"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
    </div>
  );
};

const SpinnerPro = ({
  question,
  handleClick,
  containerIndex,
  questionIndex,
}) => {
  const dispatch = useDispatch();

  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  const handleChangeProp = (e, containerIndex) => {
    const { name, value } = e.target;
    dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
  };
  return (
    <div className="questionContainer">
      <div className="propertiesTop">
        <p className="propertiesTitle">Short text properties</p>
        <img
          src={propertiesCloseIcon}
          alt="propertiesCloseIcon"
          style={{ cursor: "pointer" }}
          onClick={handleClick}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Field label</p>
        <ReactQuill
          theme="snow"
          className="customs"
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Sub label</p>
        <textarea
          className="propertiesTextArea"
          value={question.sublabel}
          name="sublabel"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Entry limit</p>
        <div className="Characterlimit">
          <input
            className="propertiesInput"
            value={question.minValue}
            name="minValue"
            onChange={(e) => handleChangeProp(e, containerIndex)}
          />
          <input
            className="propertiesInput"
            value={question.maxValue}
            name="maxValue"
            onChange={(e) => handleChangeProp(e, containerIndex)}
          />
        </div>
      </div>

      <div className="textInputContainer">
        <p className="propertiesText">Interval Amount</p>
        <input
          className="propertiesInputN"
          value={question.intervelAmount}
          placeholder="00"
          name="intervalAmount"
          type="number"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
    </div>
  );
};

const DateTimePro = ({
  question,
  handleClick,
  containerIndex,
  questionIndex,
}) => {
  const dispatch = useDispatch();
  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  const handleChangeProp = (e, containerIndex) => {
    if (e.name === "dateFormat") {
      const { name, value } = e;
      dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
    } else {
      const { name, value } = e.target;
      dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
    }
  };

  const customStyles = {
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? "#1B51BB66" : "#fff",
      ":hover": {
        backgroundColor: "none",
      },
    }),
  };

  const colourOptions = [
    { name: "dateFormat", value: "MM - DD - YYYY", label: "MM - DD - YYYY" },
    { name: "dateFormat", value: "DD - MM - YYYY", label: "DD - MM - YYYY" },
    { name: "dateFormat", value: "YYYY - MM - DD", label: "YYYY - MM - DD" },
  ];
  const options = [
    { value: "Mon", label: "Monday" },
    { value: "Tue", label: "Tuesday" },
    { value: "Wed", label: "Wednesday" },
    { value: "Thu", label: "Thursday" },
    { value: "Fri", label: "Friday" },
    { value: "Sat", label: "Saturday" },
    { value: "Sun", label: "Sunday" },
  ];
  // Custom Option component to include a checkbox
  const CheckboxOption = (props) => {
    return (
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null} // Prevents checkbox from being unchecked directly
        />{" "}
        <label>{props.label}</label>
      </components.Option>
    );
  };

  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleChange = (selected) => {
    setSelectedOptions(selected);
    const selectedNames = selected
      ? selected.map((option) => option.label)
      : [];
    console.log("Selected options:", selectedNames);
  };
  const handelAutoFill = (value, containerIndex) => {
    dispatch(updateDateAutoFill({ containerIndex, questionIndex, value }));
  };

  const [timeFormate, setTimeFormat] = useState("");
  return (
    <div className="questionContainer">
      <div className="propertiesTop">
        <p className="propertiesTitle">Time properties</p>
        <img
          src={propertiesCloseIcon}
          alt="propertiesCloseIcon"
          style={{ cursor: "pointer" }}
          onClick={handleClick}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Field label</p>
        <ReactQuill
          theme="snow"
          className="customs"
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Date format</p>
        <Select
          className="basic-single"
          styles={customStyles}
          onChange={(e) => handleChangeProp(e, containerIndex)}
          name="dateFormat"
          options={colourOptions}
          value={question.dateFormat}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Allow dates of week</p>
        <Select
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          styles={customStyles}
          components={{ Option: CheckboxOption }}
          options={options}
          value={selectedOptions}
          onChange={handleChange}
          placeholder="Select flavors"
        />
      </div>
      <p className="propertiesText">Sublabel label</p>
      <div className="namePlaceHolder">
        <div className="nameInputContainer">
          <p className="name-value">Hour</p>
          <input
            value={question.firstName}
            name="Hour"
            type="number"
            onChange={(e) => handleChangeProp(e, containerIndex)}
          />
        </div>
        <hr />
        <div className="nameInputContainer">
          <p className="name-value">Minutes</p>
          <input
            value={question.lastName}
            name="Minutes"
            type="number"
            onChange={(e) => handleChangeProp(e, containerIndex)}
          />
        </div>
      </div>
      <div className="time-form-container">
        <p className="propertiesText">Time format</p>
        <div className="time-format-container">
          <div
            className="time-format H12"
            style={{
              backgroundColor: timeFormate === "12H" ? "#1B51BB" : "#ffffff",
              color: timeFormate === "12H" ? "#ffffff" : "#8493B2",
            }}
            onClick={() => setTimeFormat("12H")}
          >
            12 Hours
          </div>
          <div
            className="time-format H24"
            style={{
              backgroundColor: timeFormate === "24H" ? "#1B51BB" : "#ffffff",
              color: timeFormate === "24H" ? "#ffffff" : "#8493B2",
            }}
            onClick={() => setTimeFormat("24H")}
          >
            24 Hours
          </div>
        </div>
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Error text </p>
        <input
          className="propertiesInput"
          value={question.errorText}
          placeholder="This is a required question"
          name="errorText"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
    </div>
  );
};

const DropDownPro = ({
  question,
  handleClick,
  containerIndex,
  questionIndex,
}) => {
  const dispatch = useDispatch();
  const handleQuestionChange = (newQuestion) => {
    console.log(question);
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  const handleChangeProp = (e, containerIndex) => {
    if (e.name === "Domain") {
      const { name, value } = e;
      dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
    } else {
      const { name, value } = e.target;
      dispatch(updatevalueFrom({ name, value, containerIndex, questionIndex }));
    }
  };
  const customStyles = {
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? "#E0E7F7" : "#fff",
      ":hover": {
        backgroundColor: "none",
      },
    }),
  };
  const colourOptions = [
    { label: "None ", value: "None" },
    { label: "Day", value: "Day" },
    { label: "Month", value: "Month" },
    { label: "Gender", value: "Gender" },
    { label: "Time Zones", value: "Time Zones" },
    { label: "Countries", value: "Countries" },
  ];

  const [countries, setCountries] = useState([]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get("https://restcountries.com/v3.1/all");
        const countryNames = response.data.map(
          (country) => country.name.common
        );
        setCountries(countryNames);
      } catch (error) {
        console.error("Error fetching the countries:", error);
      }
    };

    fetchCountries();
  }, []);

  const findOption = useCallback(
    (type) => {
      switch (type) {
        case "Gender":
          return ["Male", "Female", "N/A"].map((value) => ({
            id: uuidv4(),
            value,
          }));
        case "Day":
          return [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday",
          ].map((value) => ({
            id: uuidv4(),
            value,
          }));
        case "Time Zones":
          return ["GMT", "CST", "EST", "PST", "MST"].map((value) => ({
            id: uuidv4(),
            value,
          }));
        case "Countries":
          return countries; // Countries already contain id and value
        case "Month":
          return [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ].map((value) => ({
            id: uuidv4(),
            value,
          }));
        case "None":
        default:
          break;
      }
    },
    [countries]
  );
  const handleUpdateOption = (optionValue) => {
    const selectedOption = findOption(optionValue.value);
    dispatch(
      updateOpton({
        selectedOption,
        questionIndex,
        containerIndex,
      })
    );
  };

  return (
    <div className="questionContainer">
      <div className="propertiesTop">
        <p className="propertiesTitle">Single choice properties</p>
        <img
          src={propertiesCloseIcon}
          alt="propertiesCloseIcon"
          style={{ cursor: "pointer" }}
          onClick={handleClick}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Field label</p>
        <ReactQuill
          theme="snow"
          className="customs"
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Sub label</p>
        <textarea
          className="propertiesTextArea"
          value={question.sublabel}
          name="sublabel"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Place holder text</p>
        <input
          className="propertiesInput"
          value={question.placeHolder}
          name="placeHolder"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Predefined option</p>
        <Select
          className="basic-single"
          styles={customStyles}
          onChange={(e) => handleUpdateOption(e)}
          name="character"
          options={colourOptions}
        />
        <p className="ready-made-optiontext">
          Choose a ready-made list of options (e.g., U.S. states, days, months,
          etc.)
        </p>
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Error text </p>
        <input
          className="propertiesInput"
          value={question.errorText}
          placeholder="This is a required question"
          name="errorText"
          onChange={(e) => handleChangeProp(e, containerIndex)}
        />
      </div>
    </div>
  );
};

const MultipleChoice = ({
  question,
  questionIndex,
  activeContainerIndex,
  handleClick,
}) => {
  const dispatch = useDispatch();
  const handleChangeProp = (e, activeContainerIndex) => {
    const { name, value } = e.target;
    dispatch(
      updatevalueFrom({ name, value, activeContainerIndex, questionIndex })
    );
  };
  return (
    <div className="questionContainer">
      <div className="propertiesTop">
        <p className="propertiesTitle">Short text properties</p>
        <img
          src={propertiesCloseIcon}
          alt="propertiesCloseIcon"
          style={{ cursor: "pointer" }}
          onClick={handleClick}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Field label</p>
        <input
          className="propertiesInput"
          value={question.question}
          name="question"
          onChange={(e) => handleChangeProp(e, activeContainerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Sub label</p>
        <textarea
          className="propertiesTextArea"
          value={question.sublabel}
          name="sublabel"
          onChange={(e) => handleChangeProp(e, activeContainerIndex)}
        />
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Choices</p>
        {question.options.map((option) => {
          return (
            <div key={option.id} className="singleChoiceproOp">
              <img src={singleCProDndIcon} alt="dndicon" />
              <input className="propertiesInput" value={option.optionText} />
              <img src={singleCProDeleteIcon} alt="deleteIcon" />
              <img src={singleCProAddIcon} alt="addIcon" />
            </div>
          );
        })}
      </div>
      <div className="textInputContainer">
        <p className="propertiesText">Predefined option</p>
        <input
          className="propertiesInput"
          value={question.PredefinedOption}
          name="question"
        />
      </div>
    </div>
  );
};
